<template>
    <button
        :aria-expanded="menuActive.toString()"
        class="menu-button"
        @click="toggleMenu()"
    >
        <span class="menu-button__hamburger">
            <span class="menu-button__bread menu-button__bread--top">
                <span class="menu-button__bread-crust menu-button__bread-crust--top" />
            </span>
            <span class="menu-button__bread menu-button__bread--bottom">
                <span class="menu-button__bread-crust menu-button__bread-crust--bottom" />
            </span>
        </span>
        <span
            class="menu-label"
            v-text="menuActive ? 'Close' : 'Menu'"
        />
    </button>
</template>

<script>
import { container } from '@/js/util/menu';

export default {
    name: 'MenuButton',
    defaultTag: 'div',
    inject: { container },
    data() {
        return {
            menuActive: false,
        };
    },
    methods: {
        toggleMenu() {
            this.container.$emit('toggleMenu');
            this.menuActive = !this.menuActive;
            const alerts = document.getElementsByClassName('alert-bar');
            if (alerts !== undefined && alerts.length !== 0) {
                for (let i = 0; i < alerts.length; i += 1) {
                    if(this.menuActive){
                        alerts[i].style.display = `none`;
                    } else {
                        alerts[i].style.display = `inherit`;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss">
$menu-button-height: $menu-button-height;
$menu-button-width: 105px;
$hamburger-size: 42px;
$crust-height: 2px;
$crust-position: ($hamburger-size / 2) - ($crust-height / 2);

.menu-button {
    @include reset-button;
    position: relative;
    width: $menu-button-width;
    height: $menu-button-height;
    cursor: pointer;
    background-color: $glow-red;

    &:hover,
    &:focus {
        background-color: darken($glow-red, 5%);
    }
}

.menu-button__hamburger {
    position: absolute;
    top: ($menu-button-height - $hamburger-size) / 2 + 1px;
    z-index: 3;
    display: block;
    width: $hamburger-size;
    height: $hamburger-size;
    transition:
        opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1),
        transform 0.4s cubic-bezier(0.4, 0.01, 0.165, 0.99);
    -webkit-tap-highlight-color: transparent;
}

.menu-button__bread {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: $hamburger-size;
    height: $hamburger-size;
    transition: opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &--top {
        transition: transform 0.25s cubic-bezier(0.4, 0.01, 0.165, 0.99);
        transform: rotate(0);
    }

    &--bottom {
        transition: transform 0.25s cubic-bezier(0.4, 0.01, 0.165, 0.99);
        transform: rotate(0);
    }
}

.menu-button__bread-crust {
    position: absolute;
    left: $hamburger-size / 3;
    z-index: 1;
    display: block;
    width: $hamburger-size / 3;
    height: $crust-height;
    background: $white;
    transition: transform 0.2s;

    &--top {
        top: $crust-position;
        transition: transform 0.2s 0.2s;
        transform: translateY(-3px);
    }

    &--bottom {
        bottom: $crust-position;
        transform: translateY(3px);
    }
}

.menu-label {
    @include menu-label;
    position: absolute;
    top: 50%;
    left: $hamburger-size - 5px;
    display: inline-block;
    margin-top: -1px;
    color: $white;
    transform: translateY(-25%);

    @include breakpoint(medium) {
        left: $hamburger-size;
    }
}

.menu-button[aria-expanded="true"] {
    .menu-button__hamburger {
        transform: rotate(90deg);
    }

    .menu-button__bread-crust {
        &--top {
            transform: rotate(45deg);
        }

        &--bottom {
            transform: rotate(-45deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuButton.vue